export default __webpack_public_path__ + "_/images/gift-box-4e2801d095470635adcdc21a6b9e055833302ddf14b25d9ab696f713729e5e64.gif";